import { CircularProgress, Modal } from "@mui/material";
import { Box } from "@mui/material";
import SoftBox from "components/SoftBox";
import { useEffect, useState } from "react";
import StyledButton from "../../../custom/StyledButton";
import { Typography } from "@mui/material";
import "./index.css";
import { AvailableOffers } from "./components/availableOffer";

export const OfferCheckModal = ({
  offerCheckModal,
  handleCloseOfferCheckModal,
  setOfferFound,
  offerListData,
  showOffer,
}) => {
  const [loader, setLoader] = useState(false);
  const retailType = localStorage.getItem("retailType");

  const styleOffers = {
    position: "absolute",
    top: "45%",
    left: "45%",
    transform: "translate(-40%, -45%)",
    width: "60%",
    height: showOffer ? "500px" : "150px",
    bgcolor: "background.paper",
    borderRadius: "10px",
    boxShadow: 24,
    p: 4,
    overflowY: "scroll",
  };

  const proceedWithoutOffer = () => {
    setOfferFound(false);
    handleCloseOfferCheckModal();
  };

  const handleGoToCart = () => {
    handleCloseOfferCheckModal();
  };

  return (
    <Modal open={offerCheckModal} onClose={handleCloseOfferCheckModal}>
      <Box sx={styleOffers} className="offer-wrappper-main-box">
        {loader ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "400px",
            }}
          >
            <CircularProgress color="success" sx={{ color: "#5271ff" }} size={40} />
          </Box>
        ) : (
          <>
            {retailType !== "RESTAURANT" && (
              <>
                <div className="circle-bg-image-9"></div>
                <div className="circle-bg-image-10"></div>
              </>
            )}
            {showOffer && (
              <>
                <Typography variant="h4" sx={{ fontSize: "1.7rem", fontWeight: "bold" }}>
                  Your cart offers
                </Typography>
                <SoftBox sx={{ height: "88%", overflow: "scroll" }} mb={2}>
                  <AvailableOffers offerListData={offerListData} />
                </SoftBox>
              </>
            )}
          </>
        )}
        {showOffer && (
          <SoftBox className="offer-check-modal-btn-main">
            <StyledButton fullWidth onClick={handleGoToCart} autoFocus>
              Go to Cart
            </StyledButton>
            <StyledButton fullWidth onClick={proceedWithoutOffer}>
              Proceed without offer
            </StyledButton>
          </SoftBox>
        )}
      </Box>
    </Modal>
  );
};
